/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

import AppConst from '../../constants/app.constant';
import { getSettingFromLocalstorage } from '../../services/localstorage/getSettingFromLocalstorage';

function mapViewDataSource() {
  const methods = {};
  methods.refreshRouteFormSettings = () => {
    methods.routeFormSettings = getSettingFromLocalstorage(AppConst
      .localstorageConf.routeprofileSettingKey);
  };
  methods.airportSequence = null;
  methods.flightRules = {};
  methods.routeMap = {};
  methods.fullData = {};
  methods.getFlightRule = () => methods.flightRules;
  methods.setFlightRule = function (rules) {
    methods.flightRules = rules;
  };
  methods.setAirportSequence = function (airportSequence) {
    methods.airportSequence = airportSequence;
  };
  methods.setRouteMap = function (routeMap) {
    methods.routeMap = routeMap;
  };
  methods.setFullData = function (fullData) {
    // This object contains MAV and LAMP mode data
    methods.fullData = fullData;
  };
  methods.cleanFactory = () => {
    methods.data = null;
    methods.airportSequence = null;
    methods.processed = false;
    methods.flightRules = {};
    methods.routeMap = {};
    methods.fullData = {};
  };
  return methods;
}
export default mapViewDataSource();
